jQuery(window).on('resize load', function () {
  jQuery('.component-comparison').addClass('js-component-comparison');
  var height = Math.abs(parseInt(jQuery('.js-component-comparison .text-body').height()));
  var top = Math.abs(parseInt(jQuery('.js-component-comparison .content').css('top')));
  var bottom = Math.abs(parseInt(jQuery('.js-component-comparison .content').css('bottom')));
  jQuery('.component-comparison').css('height',  height - top - bottom);
});
